const html = (i) => `
<html>
    <head>
        <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css"
        />
        <style>
        @media print {
            @page {
            size: A5 landscape;
            }
        }
        </style>
    </head>
    <body class="A5 landscape" style="font-family: monospace;">
        <section class="sheet padding-10mm">
        <!-- Başlık -->
        <article>SERTEL GRUP LOJİSTİK A.Ş.</article>
        <article>FİŞ TİPİ : ${i.FisTipi || '*'}</article>
        <br />

        <!-- Fiş No ve Sağdaki Bilgiler -->
        <table style="width:100%; border-collapse:collapse;">
            <tr>
            <!-- Sol taraf: Fiş No -->
            <td style="width:50%; vertical-align: top;">
                <table style="border-collapse: collapse;">
                <tr>
                    <td>Fiş No</td>
                    <td>&nbsp;:</td>
                    <td>${i.FisNo || '*'}</td>
                </tr>
                </table>
            </td>

            <!-- Sağ taraf: Kayıt Yapan / Proje Kodu / Tarih -->
            <td style="width:50%; vertical-align: top; padding-left: 20px;">
                <table style="border-collapse: collapse;">
                <tr>
                    <td>Kayıt Yapan Kul.</td>
                    <td>&nbsp;:</td>
                    <td>${i.KayitYapanKullanici || '*'}</td>
                </tr>
                <tr>
                    <td>Proje Kodu</td>
                    <td>&nbsp;:</td>
                    <td>${i.ProjeKodu || '*'}</td>
                </tr>
                <tr>
                    <td>Tarih</td>
                    <td>&nbsp;:</td>
                    <td>${i.Tarih || '*'}</td>
                </tr>
                </table>
            </td>
            </tr>
        </table>

        <br />

        <!-- Satır Detayları -->
        <table style="width:100%; border-collapse:collapse;">
            <thead>
            <tr style="border-bottom:1px dashed #ccc;">
                <td>HESAP KODU</td>
                <td>HESAP ADI</td>
                <td>AÇIKLAMA</td>
                <td>BORÇ</td>
                <td>ALACAK</td>
            </tr>
            </thead>
            <tbody>
            ${tableRows(i.Items || [])}
            <tr style="border-top:1px dashed #ccc;">
                <td colspan="2"></td>
                <td style="text-align:right; padding-right:4px;">Genel Toplam :</td>
                <td>${i.GenelBorc || '*'}</td>
                <td>${i.GenelAlacak || '*'}</td>
            </tr>
            </tbody>
        </table>

        <br /><br />

        <!-- İmza Bölümü -->
        <table style="width:100%; border-collapse:collapse;">
            <tbody>
            <tr>
                <td style="width:50%;">HAZIRLAYAN</td>
                <td style="width:50%;">ONAYLAYAN</td>
            </tr>
            <tr>
                <td>${i.Hazirlayan || '*'}</td>
                <td></td>
            </tr>
            </tbody>
        </table>
        </section>
    </body>
</html>
`

const tableRows = (rows) => {
    const rs = []
    for (let index = 0; index < rows.length; index++) {
        rs.push(`
            <tr>
                <td style="vertical-align:top;white-space: nowrap; overflow: hidden; text-overflow: clip; padding:4px;">${rows[index].HesapKodu}</td>
                <td style="vertical-align:top;padding:4px;">${rows[index].HesapAdi}</td>
                <td style="vertical-align:top;padding:4px;">${rows[index].Aciklama}</td>
                <td style="vertical-align:top;white-space: nowrap; padding:4px; white-space: nowrap; overflow: hidden; text-overflow: clip;">${rows[index].Borc}</td>
                <td style="vertical-align:top;white-space: nowrap; padding:4px; white-space: nowrap; overflow: hidden; text-overflow: clip;">${rows[index].Alacak}</td>
            </tr>
        `)
    }
    return rs.join('')
}


const settings = `toolbar=no,
location=no,
status=no,
menubar=no,
scrollbars=yes,
resizable=yes,
width=830,
height=590`

export const printTediyeFis = (i) => {
    var wnd = window.open("about:blank", "", settings);
    wnd.document.write(html(i));
    wnd.print()
}